import React from 'react';
import { formatDistanceToNow } from 'date-fns';

export default function (props) {
  if (!props.date) {
    return null;
  }

  const date = new Date(props.date);
  const formatted = formatDistanceToNow(date, { addSuffix: true });

  return (<span {...props}>{formatted}</span>);
}